import { Observable, forkJoin, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';

import { Characteristic } from '../entities/characteristic.entity';
import { CharacteristicService } from './characteristic.service';
import { Patient } from '../entities/patient.entity';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private characteristicService: CharacteristicService) {}

  /**
   * Updates characteristics of one patient
   * @param data
   * @param patientProfile
   * @returns Observable
   */
  updateCharacteristics(data = {}, patientProfile: Patient): Observable<any> {
    let observables = {};

    for (let [key, value] of Object.entries(data)) {
      const characteristic: Characteristic = patientProfile.characteristics.find(
        (item) => item.characteristicType.code.toLowerCase() == key.toLowerCase()
      );

      observables[key] = this.characteristicService
        .postPatientCharacteristic({
          value: value != null ? value.toString() : value,
          characteristicTypeCode: key,
          userId: patientProfile.getId()
        })
        .pipe(
          switchMap((res) =>
            this.characteristicService.getPatientCharacteristics(patientProfile.getId(), {
              characteristicId: res
            })
          ),
          switchMap((res) => of(res[0]))
        );
    }

    return forkJoin(observables);
  }
}
